export default {
    i18n: {
        "Access Denied.": "גישה נדחתה.",
        "Fingerprint": "טביעת אצבע",
        "Date Time": "תאריך שעה",
        "name": "שם",
        "tamperAlarm": "הגנת פריצה",
        "bluetooth": "בלוטות",
        "day": "יְוֹם",
        "Device Information": "מידע על מכשירים",
        "handset": "מכשיר",
        "Http": "Http",
        "Device Name": "שם התקן",
        "auto": "אוטומטי",
        "Group": "קְבוּצָה",
        "Volume": "ווליום",
        "Card": "כַּרְטִיס",
        "minutes": "דקות",
        "timezone": "אזור זמן",
        "Are you sure you want to delete this device?": "האם אתה בטוח שאתה רוצה למחוק את המכשיר הזה?",
        "Attendance Point Name": "שם נקודת נוכחות",
        "Mac": "מק",
        "confirmToDeleteIt?": "לאשר למחוק אותו?",
        "captureLogs": "לוג צילום",
        "Doors": "דלתות",
        "All Doors": "כל הדלתות",
        "Lock List": "רשימת נעילה",
        "Link Device Relay": "ממסר מכשירי קישור",
        "Added Successfully!": "נוסף בהצלחה!",
        "When the lock is linked with a relay, the lock will be unlocked when relay is triggered.": "כאשר המנעול מקושר לממסר, המנעול יימנע כאשר ממסר מופעל.",
        "Adding...": "מוֹסִיף...",
        "Please try again 24 hours later.": "אנא נסה שוב כעבור 24 שעות.",
        "Action": "פעולה",
        "unlock": "לבטל נעילה",
        "Address": "כתובת",
        "Owner": "בעלים",
        "Failed": "נכשל",
        "Timeout": "פסק זמן",
        "Response": "תְגוּבָה",
        "caller": "מתקשר",
        "receiver": "מקלט",
        "doorLogs": "לוג דלת",
        "callHistory": "היסטוריית שיחות",
        "UID": "UID",
        "Call Type": "סוג שיחה",
        "Code": " קוד",
        "User": "משתמש",
        "Device List": "רשימת מכשירים",
        "Model": "דֶגֶם",
        "Time": "זְמַן",
        "Company": "שם החברה",
        "Property Managers": "מנהלי נכסים",
        "Current Version": "גרסה נוכחית",
        "indoorMonitor": "צג פנימי",
        "guardPhone": "עמדת שומר",
        "close": "סגור",
        "Success": "הצלחה",
        "URL": "כתובת אתר",
        "Please select a device.": "אנא בחר מכשיר.",
        "Password is too weak.": "הסיסמה חלשה מדי.",
        "Company is required.": "יש צורך בחברה.",
        "Your account is not activated, please contact your service provider.": "חשבונך אינו מופעל, אנא צור קשר עם ספק השירות שלך.",
        "Language": "שפה",
        "Face": "פנים",
        "Please set at least one access type.": "אנא קבע לפחות סוג גישה אחת.",
        "Please contact your service provider to activate this advanced feature.": "אנא צור קשר עם ספק השירות שלך כדי להפעיל תכונה מתקדמת זו.",
        "Community name": "שם קהילה",
        "Please enable PM App first.": "אנא הפעל תחילה את אפליקציית המנהל ",
        "Username": "שם משתמש",
        "Change Log": "שנה לוג",
        "Assign": "לְהַקְצוֹת",
        "Floor": "קוֹמָה",
        "Link Device": "קישור מכשיר",
        "Accessible Floors": "קומות נגישות",
        "Upgrade": "שדרוג",
        "Function": "פוּנקצִיָה",
        "callDuration": "משך שיחה",
        "No": "לא",
        "Verification Code": "קוד אימות",
        "Expiration Time": "תאריך תפוגה",
        "PIN": "קוד",
        "MAC": "מק",
        "Building": "בניין",
        "APT": "דירה",
        "ID": "תעודת זהות",
        "Name": "שם",
        "activities": "פעילויות",
        "Obtain": "לְהַשִׂיג",
        "call": "שִׂיחָה",
        "Group Call": "שיחה קבוצתית",
        "Delete": "לִמְחוֹק",
        "Yes": "כן",
        "Door Release PIN": "קוד פתיחה אישי",
        "Email": "אֶלֶקטרוֹנִי",
        "Mobile Number doesn\'t exist.": "מספר נייד לא קיים.",
        "Tips": "טיפים",
        "Password": "סיסמה",
        "The end time cannot be earlier than the start time.": "!זמן הסיום אינו פחות משעת ההתחלה",
        "Back": "חזור",
        "File format error.": "שגיאה בפורמט הקובץ.",
        "motionDetection": "גלאי תנועה",
        "You are trying too often, please try again in 5 minutes": "אתה מנסה לעתים קרובות מדי, אנא נסה שוב בעוד 5 דקות",
        "User name too long.": "שם המשתמש ארוך מדי.",
        "This MAC address is redirected on RPS.": "כתובת ה-MAC הזו מופנית ב-RPS.",
        "No Answer": "אין תשובה",
        "failedToUnlock": "פתיחה נכשלה",
        "visitor": "אורח",
        "yesterday": "אתמול",
        "Too large data! Please first export the data before %s first,thanks.": "קובץ גדול מידי",
        "Please check if there is any unpaid orders, if not, please contact your service provider.": "אנא בדוק אם יש הזמנות שלא שולמו, אם לא, אנא צור קשר עם ספק השירות שלך",
        "lock": "סגור דלת",
        "open": "אבטחה פתוחה",
        "The PersonalAccount is not active.": "החשבון האישי אינו פעיל.",
        "You cannot link an account that already link other accounts.": "אינך יכול לקשר חשבון שכבר מקשר חשבונות אחרים.",
        "You cannot link multiple property manager accounts under the same installer account.": "אינך יכול לקשר חשבונות של מנהל נכסים מרובים תחת אותו חשבון מתקין.",
        "You cannot link to the currently logged in account.": "אינך יכול לקשר לחשבון המחובר כעת.",
        "nfc": "NFC",
        "Delete Device": "מחק מכשיר",
        "date": "תַאֲרִיך",
        "Device deleted successfully": "המכשיר נמחק בהצלחה",
        "Failed to delete device": "מחק מכשיר נכשל",
        "Are you sure you want to cancel?": "האם אתה בטוח שברצונך לבטל?",
        "Unlimited": "ללא הגבלה",
        "Battery Level": "רמת סוללה",
        "Password Incorrect.": "סיסמא לא נכונה.",
        "deliverySystemVerification": "אימות מערכת מסירה",
        "None": "אף אחד",
        "Upgrading...": "מעדכן...",
        "amenityReservation": "הזמנת נוחות",
        "idAccess": "גישה למזהה",
        "RF Card": "כרטיס RF",
        "exitButton": "כפתור יציאה",
        "Please select at least one item.": "אנא בחר לפחות פריט אחד.",
        "The ID can contain only digits and letters, up to 32 characters.": "המזהה יכול להכיל רק ספרות ומכתבים, עד 32 תווים.",
        "The PIN is not available.": "הסיכה אינה זמינה.",
        "Change WiFi": "שנה רשת אלחוטית",
        "Phone number": "מספר טלפון",
        "Invalid {0}.": "{0} לא חוקי.",
        "{0} already exists.": "{0} כבר קיים.",
        "Operation failed!": "הפעולה נכשלה!",
        "Failed to get data.": "נכשל בנתונים.",
        "You do not have the necessary permissions to perform this operation.": "אין לך את ההרשאות הדרושות לביצוע פעולה זו.",
        "You can only import one template at a time in the current site.": "אתה יכול לייבא רק תבנית אחת בכל פעם באתר הנוכחי.",
        "Delivery name": "שם משלוח",
        "MAC address not in the MAC library.": "כתובת MAC לא בספריית MAC.",
        "Please delete devices under this building.": "אנא מחק מכשירים תחת בניין זה.",
        "The start time cannot be later than the end time.": "זמן ההתחלה לא יכול להיות מאוחר יותר משעת הסיום.",
        "emergency action type": "סוג פעולה חירום",
        "Only 1000 data items can be imported at a time.": "ניתן לייבא רק 1000 פריטי נתונים בכל פעם.",
        "The password is too short.": "הסיסמה קצרה מדי.",
        "The data has been updated. Please refresh the page and try again.": "הנתונים עודכנו. אנא רענן את הדף ונסה שוב.",
        "AutoP length must be less 2048 bytes.": "אורך אוטומטי חייב להיות פחות 2048 בתים.",
        "File Check Failed": "בדיקת הקבצים נכשלה",
        "administratorAccountLoginHasExpired.PleaseContactYourServiceProvider.": "תוקף הכניסה לחשבון המנהל פג. אנא פנה לספק השירות שלך.",
        "iqPinVerificationFailed": "אימות קוד ה-IQ נכשל.",
        "accountBlacklisted": "החשבון נכנס לרשימת השחורים.",
        "outsideAuthorizedTime": "מחוץ לזמן המורשה.",
        "network group": "קבוצת רשת",
        "Company name": "שם החברה",
        "Group name": "שם הקבוצה",
        "relay": "ממסר",
        "motionTime": "זמןזיהויגתנועה",
        "motionType": "סוגתנועה",
        "postalCode": "מיקוד",
        "floor format": "פורמט קומה",
        "mobilePhone": "מספרטלפוןנייד",
        "time format": "פורמט זמן",
        "security relay": "ממסר אבטחה",
        "Param": "פרמטר",
        "Offline Code": "קוד לא מקוון",
        "Add akubela Smart Locks": "הוסף מנעולים חכמים של akubela",
        "Module Version": "גרסת מודול",
        "Lock Body Version": "גרסת גוף המנעול",
        "Available Version": "גרסה זמינה",
        "Please wake up the lock screen and then upgrade.": "אנא העירו את מסך הנעילה ולאחר מכן שדרגו.",
        "This process will take some time, please be patient.": "תהליך זה ייקח זמן מה, אנא היו סבלניים.",
        "Please confirm that the WiFi network is functioning properly.": "אנא אשר שהרשת האלחוטית פועלת כראוי.",
        "Please wake up the lock screen.": "אנא העירו את מסך הנעילה.",
        "This lock has already been added to another apartment.": "המנעול הזה כבר נוסף לדירה אחרת.",
        "This lock has already been added to the apartment.": "המנעול הזה כבר נוסף לדירה.",
        "Pin Code": "קוד סודי",
        "Too many failed attempts, please try again in a few minutes.": "יותר מדי ניסיונות כושלים, אנא נסה שוב בעוד מספר דקות.",
        "Login Account": "התחברות לחשבון",
        "Same account cannot login in different ins.": "לא ניתן להיכנס עם אותו חשבון במתקינים שונים.",
        "Lock Name": "שם המנעול",
        "Smart Locks": "מנעולים חכמים",
        "Add Smart Lock": "הוסף מנעול חכם",
        "The selected duration cannot be more than one year.": "משך הזמן שנבחר לא יכול להיות יותר משנה.",
        "The end time of the break time cannot be later than the end work time.": "זמן סיום ההפסקה לא יכול להיות מאוחר מזמן סיום העבודה.",
        "The start time of the break time cannot be earlier than the start work time.": "שעת תחילת ההפסקה לא יכולה להיות מוקדמת יותר משעת תחילת העבודה.",
        "The end time of the valid check time cannot be earlier than the end work time.": "זמן סיום של זמן הבדיקה התקף לא יכול להיות מוקדם מזמן סיום העבודה.",
        "The start time of the valid check time cannot be later than the start work time.": "שעת ההתחלה של זמן הבדיקה התקף לא יכולה להיות מאוחרת משעת תחילת העבודה.",
        "Deleting failed. The timetable is used by a shift.": "המחיקה נכשלה. לוח הזמנים בשימוש על ידי משמרת.",
        "Deleting failed. The shift is in use.": "המחיקה נכשלה. המשמרת נמצאת בשימוש.",
        "Deleting failed. The leave type is in use.": "המחיקה נכשלה. סוג החופשה נמצא בשימוש.",
        "Valid time conflicts with an existing schedule.": "הזמן התקף מתנגש עם לוח זמנים קיים.",
        "The timing for multiple schedules must not coincide.": "הזמנים של לוחות הזמנים השונים אינם יכולים לחפוף.",
        "Attendance Log": "יומן נוכחות",
        "Added Failed!": "הוספה נכשלה!",
        "Setting WiFi": "הגדרת WiFi",
        "License Plate": "לוחית רישוי",
        "key": "סיסמה",
        "IQ Offline.": "IQ לא מקוון.",
        "{0}Unlock": "פתח את {0}",
        "automatically": "אוטומטית",
        "manually": "ידנית",
        "Video Storage": "אחסון וידאו",
        "Device(s) for Video Storage": "התקן(ים) לאחסון וידאו",
        "The amount of exported data is too large. Please export it in batches.": "כמות הנתונים המיוצאת גדולה מדי. אנא ייצא אותם במנות.",
        "Auto-record video when door unlocks": "הקלט וידאו אוטומטית כאשר הדלת נפתחת",
        "Auto-record video during calls": "הקלטת וידאו אוטומטית במהלך שיחות",
        "Manual video recording in monitoring": "הקלטת וידאו ידנית במעקב",
        "Saved for 30days/60days/90days": "נשמר ל-30 ימים / 60 ימים / 90 ימים",
        "To subscribe, please contact your provider for activation.": "כדי להירשם, אנא פנה לספק שלך לצורך הפעלה.",
        "Saved for {0}days": "נשמר ל־{0} ימים",
        "Subscribed Plan": "תוכנית מנוי",
        "Supported Devices: {0}": "מכשירים נתמכים: {0}",
        "{0}Lock": "נעילת {0}",
        "Video Saving": "שמירת וידאו",
        "Download Completed!": "ההורדה הושלמה!",
        "Fail to download.": "ההורדה נכשלה.",
        "Deleting failed! The property manager has been bound to a RentManager Customer, you should delete it firstly.": "המחיקה נכשלה! מנהל הנכס מקושר ללקוח RentManager, עליך למחוק אותו תחילה.",
        "No log to be exported.": "אין רשומות לייצוא.",
        "capture&Video": "צילום מסך ווידאו",
        "packageDetection": "זיהוי חבילה",
        "Time format is invalid.": "פורמט הזמן אינו חוקי.",
        "No permission to export logs of this type.": "אין הרשאה לייצא יומנים מסוג זה.",
        "Project type is invalid.": "סוג הפרויקט אינו חוקי.",
        "Salto Account Blocked.": "החשבון שלך ב-Salto נחסם.",
        "Remote open not in access group.": "פתיחה מרחוק אינה אפשרית – המשתמש אינו בקבוצת הגישה.",
        "SIP Account required.": "נדרש חשבון SIP.",
        "The PIN must be {0} digits.": "ה-PIN חייב להיות בן {0} ספרות.",
        "gatewayConnectionUnavailable": "החיבור לשער אינו זמין.",
        "Invalid Username or Password": "שם משתמש או סיסמה שגויים",
        "Account already linked to another user.": "החשבון כבר מקושר למשתמש אחר.",
        "The account has been added by another user.": "החשבון נוסף על ידי משתמש אחר.",
        "Failed to add. This user already has 5 license plates.": "ההוספה נכשלה. למשתמש זה כבר יש 5 לוחות רישוי.",
        "Please at least select a door.": "אנא בחר לפחות דלת אחת.",
        "UHF Card": "כרטיס UHF",
        "personnel": "צוות",
        "Parking Lot Name": "שם החניון",
        "Controlled Relay": "ממסר מבוקר",
        "No Permission": "אין הרשאה",
        "Please ensure that all doors in the project are activated at the same time.": "אנא ודא שכל הדלתות בפרויקט מופעלות בו-זמנית.",
        "gatewayBusy": "השער עסוק",
        "Please set the perimeter door group first.": "אנא הגדר תחילה את קבוצת דלת ההיקף.",
        "Please ensure that all doors in the project are renewed at the same time.": "אנא ודא שכל הדלתות בפרויקט יחודשו בו זמנית.",
        "When lockdown is on, the controlled relay cannot be modified.": "כאשר הסגר מופעל, לא ניתן לשנות את הממסר המבוקר.",
        "DetectionLogs": "יומני זיהוי",
        "packageIn": "החבילה הוכנסה",
        "packageOut": "החבילה נלקחה החוצה",
        "View Progress": "הצג התקדמות",
        "Check if the WiFi is operating on the 2.4GHz band.": "בדוק אם ה־WiFi פועל בתדר 2.4GHz.",
        "Verify that the WiFi password is correct.": "וודא שסיסמת ה-WiFi נכונה.",
        "Ensure that you are connected to the correct device hotspot during the hotspot configuration.": "ודא שאתה מחובר לנקודת הגישה הנכונה של המכשיר במהלך הגדרת נקודת הגישה.",
        "Offline Code Unlock": "פתיחת דלת באמצעות קוד לא מקוון",
        "Salto Token Expired.": "אסימון Salto פג תוקף.",
        "Lock Offline": "מנעול לא מקוון",
        "identity information! Please login again": "מידע זהות! אנא התחבר שוב",
        "Email is required.": "נדרש דוא\"ל.",
        "Mobile number is required.": "נדרש מספר נייד.",
        "You can\'t make payments for offices in different time zones.": "אינך יכול לבצע תשלומים עבור משרדים באזורי זמן שונים.",
        "The current scheduling staff exceeds 200 people.": "צוות התיאום הנוכחי עולה על 200 אנשים.",
        "param": "פרמטר",
        "Invalid UserName or Password": "שם משתמש או סיסמה שגויים",
        "Your Salto KS account does not have permission to modify the lock\'s name.": "לחשבון Salto KS שלך אין הרשאה לשנות את שם המנעול.",
        "Owner is required.": "נדרש בעלים.",
        "Office is required.": "נדרש משרד.",
        "PIN or RF Card is required.": "נדרש PIN או כרטיס RF.",
        "RF card": "כרטיס RF",
        "Personnel is required.": "נדרש כוח אדם.",
        "email address": "כתובת דוא\"ל",
        "mobile number": "מספר נייד",
        "The length must be less than 32 characters.": "האורך חייב להיות פחות מ-32 תווים.",
        "The length must be less than 256 characters.": "האורך חייב להיות פחות מ-256 תווים.",
        "Access Group is required.": "נדרש Access Group.",
        "Device is required.": "נדרש מכשיר.",
        "Admin is required.": "נדרש מנהל.",
        "Mobile number": "מספר נייד",
        "schedules": "לוחות זמנים",
        "Timetable name": "שם לוח זמנים",
        "Shift name": "שם המשמרת",
        "Leave type": "סוג חופשה",
        "recheck in time": "בדוק מחדש בזמן",
        "recheck out time": "זמן יציאה מחדש",
        "The building name": "שם הבניין",
        "Building is required.": "נדרש בניין.",
        "selection, The same reader cannot be set for both entry and exit": "בחירה, לא ניתן להגדיר את אותו קורא גם לכניסה וגם ליציאה",
        "Door number": "מספר דלת",
        "door input cannot be selection duplicated.": "קלט הדלת לא יכול להיות בחירה כפולה.",
        "Group is required.": "נדרש קבוצה.",
        "Title can contain up to 32 characters.": "הכותרת יכולה להכיל עד 32 תווים.",
        "Content can contain up to 1024 characters.": "תוכן יכול להכיל עד 1024 תווים.",
        "Content can contain up to 64 characters.": "תוכן יכול להכיל עד 64 תווים.",
        "Report is required.": "נדרש דוח.",
        "ID is required.": "נדרש מזהה.",
        "The office does not exist.": "המשרד אינו קיים.",
        "Office name": "שם המשרד",
        "The Temp Key does not exist.": "מפתח הזמני אינו קיים.",
        "autolock time": "זמן נעילה אוטומטית",
        "The User does not exist.": "המשתמש אינו קיים.",
        "The Installer does not exist.": "המַתְקִין אינו קיים.",
        "The Project does not exist.": "הפרויקט לא קיים.",
        "The Distributor does not exist.": "המפיץ אינו קיים.",
        "The Community Device does not exist.": "התקן הקהילתי אינו קיים.",
        "The Property Manager does not exist.": "מנהל הנכס אינו קיים.",
        "The Sub Distributor does not exist.": "הסוכן המשני אינו קיים.",
        "The Single Slave does not exist.": "העבד הבודד אינו קיים.",
        "The Property Manager EndUser does not exist.": "מנהל הנכס EndUser אינו קיים.",
        "The Family Member does not exist.": "חבר המשפחה אינו קיים.",
        "Set Failed!": "ההגדרה נכשלה!",
        "You have reached the limit of 10 access code requests within a 30-minute period. Please try again later.": "הגעת למגבלת 10 בקשות לקוד גישה בתוך פרק זמן של 30 דקות. אנא נסה שוב מאוחר יותר.",
        "This Email doesn\'t exist.": "האימייל הזה לא קיים.",
        "detection type": "סוג זיהוי",
        "Device UUID": "מזהה UUID של המכשיר",
        "smart lock device": "מכשיר מנעול חכם",
        "You are trying too often, please try again in 5 minutes.": "אתה מנסה לעיתים קרובות מדי, אנא נסה שוב בעוד 5 דקות.",
        "You can only import one file at a time. Please wait for the current import to finish.": "ניתן לייבא קובץ אחד בלבד בכל פעם. אנא המתן לסיום הייבוא הנוכחי.",
        "NVR Name": "שם אן-וי-אר",
        "NVR Address": "כתובת אן-וי-אר",
        "Stay Alarm": "אזעקת שהייה",
        "Happended On": "התרחש ב",
        "Edit Milesight NVR": "ערוך את אן-וי-אר של מיילסייט",
        "Add Milesight NVR": "הוסף אן-וי-אר של מיילסייט",
        "Auto-record video on motion detection, package detection": "הקלטת וידאו אוטומטית בזיהוי תנועה או בזיהוי חבילה",
        "A 7-day free trial is included with your subscription.": "מנוי שלך כולל תקופת ניסיון חינם של 7 ימים.",
        "For service renewal, please reach out to your provider.": "לחידוש השירות, אנא פנה לספק שלך.",
        "Allow the Property Manager to view recorded videos": "אפשר למנהל הנכס לצפות בסרטונים מוקלטים",
        "Please ensure the WiFi network is working properly.": "אנא ודא שרשת ה-WiFi פועלת כראוי.",
        "Edit akubela Smart Locks": "ערוך מנעולים חכמים של akubela",
        "Upgraded Successfully!": "שודרג בהצלחה!",
        "Upgraded Failed!": "השדרוג נכשל!",
        "Editing...": "עורך...",
        "Edited successfully!": "נערך בהצלחה!",
        "Edited Failed!": "העריכה נכשלה!",
        "Downloading video...": "מוריד וידאו...",
        "All Locks": "כל המנעולים",
        "Select Locks": "בחר מנעולים",
        "The {0} digits PIN can be used once the akubela smart lock is connected to the network. Please note that it may take a short time for the PIN to take effect after synchronization.": "ניתן להשתמש בקוד ה-PIN בן {0} ספרות לאחר שהמנעול החכם של akubela מחובר לרשת. שים לב כי ייתכן שיידרש זמן קצר עד שה-PIN ייכנס לתוקף לאחר הסנכרון.",
        "Please at least select a door or a lock.": "אנא בחר לפחות דלת אחת או מנעול אחד.",
        "This lock has already been added to your apartment.": "המנעול הזה כבר נוסף לדירתך.",
        "This lock has already been added to another apartment, please contact your service provider for assistance.": "המנעול הזה כבר נוסף לדירה אחרת, אנא פנה לספק השירות שלך לקבלת סיוע.",
        "LockBody Version": "גרסת גוף המנעול",
        "Two-factor Authentication": "אימות דו-שלבי",
        "Monitoring Scope": "היקף הניטור",
        "Stay Duration": "משך השהות",
        "Volume Settings": "הגדרות עוצמת קול",
        "get card list for lock error": "קבלת רשימת כרטיסים עבור שגיאת נעילה",
        "get card list parse fail": "קבלת רשימת כרטיסים נכשלה בפענוח",
        "get pin list for lock error": "קבלת רשימת קודי PIN עבור שגיאת נעילה",
        "get pin list parse fail": "קבלת רשימת ה-PIN נכשלה בפענוח",
        "fingerprint code must be less than 2048 characters or empty.": "קוד טביעת האצבע חייב להיות פחות מ-2048 תווים או ריק.",
        "Personnel not in office.": "הצוות לא במשרד.",
        "customize form fail.": "customize form fail.",
        "smart lock type error.": "שגיאת סוג מנעול חכם.",
        "invalid client id or secret": "מזהה לקוח או סוד שגויים",
        "invalid account or password": "חשבון או סיסמה לא חוקיים",
        "invalid access token": "אסימון גישה לא חוקי",
        "invalid refresh token": "אסימון רענון לא חוקי",
        "no permission to access this project": "אין הרשאה לגשת לפרויקט זה",
        "Stay Alarm Time": "שמור זמן אזעקה",
        "This function only support sl20 lock.": "פונקציה זו תומכת רק במנעול sl20.",
        "Json marshal error.": "שגיאת עיבוד Json.",
        "Json unmarshal error.": "שגיאת ביטול סדרה של Json.",
        "Illegal request, not added within valid time.": "בקשה בלתי חוקית, לא נוסף במסגרת הזמן התקף.",
        "invalid nvr type": "סוג nvr לא חוקי",
        "project is empty": "הפרויקט ריק",
        "project type is invalid": "סוג הפרויקט אינו חוקי",
        "owner is invalid": "הבעלים אינו חוקי",
        "url is invalid": "ה-URL אינו חוקי",
        "password is invalid": "הסיסמה אינה חוקית",
        "building is invalid": "הבניין אינו חוקי",
        "fail to get data": "נכשל בקבלת נתונים",
        "invalid allow pm view type": "סוג תצוגת pm לא חוקי מותר",
        "Data not exist.": "הנתונים אינם קיימים.",
        "cannot find community PrivateKey.": "לא ניתן למצוא את מפתח הפרטי של הקהילה.",
        "cannot find single PrivateKey.": "לא נמצא מפתח פרטי יחיד.",
        "The third party not exist.": "הצד השלישי לא קיים.",
        "{0} and indoor monitors/guard phones": "{0} ומוניטורים פנימיים/טלפוני שמירה",
        "{0} and indoor monitors/guard phones, with phone as backup": "‏{0} ומסכי פנים/טלפוני שמירה, כאשר הטלפון משמש כגיבוי",
        "Indoor monitors/guard phones with {0} as backup": "מוניטורים פנימיים/טלפוני שמירה עם {0} כגיבוי",
        "Indoor monitors/guard phones with {0} as backup, finally the phone": "מוניטורים פנימיים/טלפוני שמירה עם {0} כגיבוי, ולבסוף הטלפון",
        "{0} Intercom Feature": "תכונת האינטרקום של {0}",
        "Capture on {0}": "צילום ב־{0}",
        "{0} Intercom Feature is not activated or has expired.": "הפונקציה של האינטרקום ב־{0} אינה פעילה או שפג תוקפה.",
        "fingerprint code must be equal 1620 characters or empty.": "קוד טביעת אצבע חייב להיות באורך של 1620 תווים או ריק.",
        "To ensure a successful upgrade, please make sure the lock\'s battery level is above 40% before proceeding.": "על מנת להבטיח שדרוג מוצלח, אנא ודא שרמת הסוללה של המנעול גבוהה מ-40% לפני ההמשך.",
        "Automatic Locking Time": "זמן נעילה אוטומטי",
        "WiFi Keep-Alive": "שמירה על חיבור WiFi",
        "WiFi Setting": "הגדרות WiFi",
        "Connecting the network...": "מתחבר לרשת...",
        "Set successfully!": "הוגדר בהצלחה!",
        "The offline code can be used even if the lock is not connected to WiFi.": "ניתן להשתמש בקוד האופליין גם אם המנעול אינו מחובר ל-WiFi.",
        "Enabling this feature will increase the lock\'s power consumption.": "הפעלת תכונה זו תגדיל את צריכת החשמל של המנעול.",
        "Each offline code can only be used once.": "כל קוד לא מקוון ניתן לשימוש פעם אחת בלבד.",
        "Receiver Info": "פרטי מקבל",
        "log id": "מזהה כניסה",
        "Create HW SN Config Empty SN.": "צור HW SN Config SN ריק.",
        "The SN": "ה-SN",
        "SN can contain up to 32 characters.": "SN יכול להכיל עד 32 תווים.",
        "Check HW SN Not Found.": "בדוק HW SN לא נמצא.",
        "the end user not found": "המשתמש הסופי לא נמצא",
        "Family Call": "שיחת משפחה",
        "During the upgrade, all lock-related functions will be temporarily unavailable.": "במהלך השדרוג, כל הפונקציות הקשורות למנעול לא יהיו זמינות זמנית.",
        "8-digit PIN code starting with \"9\" is invalid!": "קוד PIN בן 8 ספרות שמתחיל ב-\"9\" אינו חוקי!",
        "Lock name length must be between 1 and 50": "אורך שם הנעילה חייב להיות בין 1 ל-50",
        "The number of personnel with landline service cannot exceed the number of those with {0} Intercom.": "מספר העובדים עם שירות קו טלפון קווי לא יכול לעלות על מספר העובדים עם שירות אינטרקום {0}.",
        "The number of admins with landline service cannot exceed the number of those with {0} Intercom.": "מספר המנהלים עם שירות טלפון קווי לא יכול לעלות על מספר המנהלים עם שירות אינטרקום {0}.",
        "charge type": "סוג חיוב",
        "The number of personnel with landline service cannot exceed the number of those with SmartPlus Intercom.": "מספר העובדים עם שירות טלפון קווי אינו יכול לעלות על מספר העובדים עם SmartPlus Intercom.",
        "The number of admins with landline service cannot exceed the number of those with SmartPlus Intercom.": "מספר המנהלים עם שירות טלפון קווי אינו יכול לעלות על מספר המנהלים עם שירות אינטרקום SmartPlus.",
        "A reader cannot be configured to use both Wiegand and RS485 simultaneously.": "לא ניתן להגדיר קורא לשימוש בו זמנית גם ב-Wiegand וגם ב-RS485.",
        "parameter error": "שגיאת פרמטר",
        "community name already exist": "שם הקהילה כבר קיים",
        "personnel app without intercom feature number": "אפליקציית עובדים ללא מספר תכונת אינטרקום",
        "check feature billing charge plan new error": "בדוק תכונה חיוב תוכנית תשלום שגיאה חדשה",
        "subscription not found": "המנוי לא נמצא",
        "System setting record not found.": "לא נמצאה רשומת הגדרת מערכת.",
        "Smart home not enabled.": "בית חכם לא הופעל.",
        "the apt call type value is invalid.": "ערך סוג השיחה של apt אינו חוקי.",
        "the ip call or sip call value is invalid.": "הערך של שיחת ip או שיחת sip אינו חוקי.",
        "pinCode must be 2-8 digit number, but cannot be an 8-digit number starting with 9 or empty.": "ה־pinCode חייב להיות מספר בן 2 עד 8 ספרות, אך לא יכול להיות מספר בן 8 ספרות שמתחיל ב־9 או ריק.",
        "rfCard must be A-F0-9 and less than 16 bits or empty.": "rfCard חייב להיות A-F0-9 ופחות מ-16 ביטים או ריק.",
        "owner cannot be empty.": "הבעלים לא יכול להיות ריק.",
        "creator cannot be empty.": "יוצר לא יכול להיות ריק.",
        "the creator type value is invalid": "ערך סוג היוצר אינו חוקי",
        "the IsCreateByPm value is invalid": "הערך של IsCreateByPm אינו חוקי",
        "the pinCode already exist": "ה־pinCode כבר קיים",
        "the rfCard already exist": "הכרטיס rfCard כבר קיים",
        "license plate is invalid.": "לוחית הרישוי אינה תקפה.",
        "owner info is invalid.": "owner info is invalid.  \nמידע הבעלים אינו תקין.",
        "uhf is invalid.": "uhf אינו חוקי.",
        "time control is invalid.": "בקרת הזמן אינה תקפה.",
        "You have reached the limit of 5 Vehicle License Plate and are not allowed to add": "הגעת למגבלה של 5 לוחיות רישוי רכב ואינך מורשה להוסיף",
        "the plate already exist": "הלוחית כבר קיימת",
        "the uhf already exist": "ה־UHF כבר קיים",
        "empty community": "קהילה ריקה",
        "no find license Plate": "לא נמצא לוחית רישוי",
        "IDAccess mode must be 0, 1, or 2.": "מצב הגישה של מזהה חייב להיות 0, 1 או 2.",
        "Run field is required when mode is 1 or 2.": "שדה ההפעלה נדרש כאשר מצב הוא 1 או 2.",
        "Serial field is required when mode is 2.": "שדה serial נדרש כאשר מצב הוא 2.",
        "the pin cannot be empty": "הקוד הסודי לא יכול להיות ריק",
        "the rfCard cannot be empty": "ה־rfCard לא יכול להיות ריק",
        "the IDAccess already exist": "ה-IDAccess כבר קיים",
        "the resident cannot be empty": "הדייר לא יכול להיות ריק",
        "the fingerprint cannot be empty": "הטביעת אצבע לא יכולה להיות ריקה",
        "the face cannot be empty": "הפנים לא יכולות להיות ריקות",
        "not found pin": "לא נמצא pin",
        "not found rfCard": "לא נמצא rfCard",
        "not found IDAccess": "לא נמצא IDAccess",
        "not found fingerprint": "לא נמצאה טביעת אצבע",
        "not found face": "לא נמצאה פנים",
        "face pic is invalid.": "תמונת הפנים אינה תקינה.",
        "community build and room cannot be empty.": "הקהילה והחדר אינם יכולים להיות ריקים.",
        "device info mac cannot be empty.": "מידע המכשיר mac לא יכול להיות ריק.",
        "scheduler type must be 0,1,2 or time format is invalid or dataflag not in 0-127.": "סוג המתזמן חייב להיות 0,1,2 או שפורמט הזמן אינו חוקי או שדגל הנתונים אינו בין 0-127.",
        "MAC address cannot be empty.": "כתובת MAC לא יכולה להיות ריקה.",
        "MAC address 0C1105000000 is not allowed.": "כתובת MAC 0C1105000000 אינה מותרת.",
        "MAC address must be 12 hexadecimal characters.": "כתובת MAC חייבת להיות בת 12 תווים הקסדצימליים.",
        "Scheduler type value is invalid.": "ערך סוג המתזמן אינו חוקי.",
        "parse is fail": "הפענוח נכשל",
        "the fingerprint already exist": "טביעת האצבע כבר קיימת",
        "the licensePlate cannot be empty": "ה-licensePlate לא יכול להיות ריק",
        "the licensePlate already exist": "הלוחית רישוי כבר קיימת",
        "idaccess run must be 10 digit number or end with -K.": "ההרצה של idaccess חייבת להיות מספר בן 10 ספרות או להסתיים ב-K.",
        "idaccess serial must be 9 digit number.": "מספר סידורי של idaccess חייב להיות מספר בן 9 ספרות.",
        "relay not in 0-15": "ממסר לא ב-0-15",
        "security relay not in 0-3": "ממסר אבטחה לא ב-0-3",
        "file name is wrong": "שם הקובץ שגוי",
        "access mode specified": "מצב גישה שצוין",
        "create community user accessmode failed.": "יצירת מצב גישה למשתמש קהילה נכשלה.",
        "delete community user accessmode failed.": "מחיקת מצב גישה של משתמש בקהילה נכשלה.",
        "Cannot delete building because it has associated users.": "לא ניתן למחוק את הבניין כי יש לו משתמשים משויכים.",
        "Cannot delete building because it has associated Salto devices.": "לא ניתן למחוק את הבניין כי הוא מקושר למכשירי Salto.",
        "community building not found": "הבניין הקהילתי לא נמצא",
        "Invalid Name Display": "תצוגת שם לא חוקי",
        "The Community does not exist.": "הקהילה אינה קיימת.",
        "Update CommunityIsInstallerKit Error.": "עדכן שגיאת CommunityIsInstallerKit.",
        "Dis Not SupportCommunityCalls Error.": "שגיאת Dis Not SupportCommunityCalls.",
        "Community Has Special Device, Not Allowed To Delete.": "לקהילה יש מכשיר מיוחד, לא ניתן למחוק.",
        "The project smart home switch must be disabled": "יש להשבית את מתג הבית החכם של הפרויקט",
        "There are ITec Locks in project": "יש ITec Locks בפרויקט",
        "There are Salto Locks in project": "יש מנעולי Salto בפרויקט",
        "There are Dormakaba Locks in project": "יש מנעולי Dormakaba בפרויקט",
        "It is rent manager project": "זהו פרויקט rent manager",
        "It is installer account": "זהו חשבון מתקין",
        "contact preference type": "סוג העדפת יצירת קשר",
        "Floor list is required when not all floors.": "נדרש רשימת קומות כאשר לא כל הקומות.",
        "Building floors list is required when all buildings.": "נדרש רשימת קומות הבניין כאשר כל הבניינים.",
        "Indoor monitor name is required.": "נדרש שם למוניטור הפנימי.",
        "The primary account is not activated.": "החשבון הראשי אינו מופעל.",
        "You can\'t create more family member accounts.": "אינך יכול ליצור חשבונות נוספים לחברי משפחה.",
        "community user not found": "משתמש קהילה לא נמצא",
        "community is empty": "הקהילה ריקה",
        "the end user not master user": "המשתמש הקצה לא המשתמש הראשי",
        "the end user not member user": "המשתמש הקצה אינו משתמש חבר",
        "The email already exists and cannot be repeated": "הדוא\"ל כבר קיים ולא ניתן לחזור עליו",
        "The mobile Number already exists": "מספר הנייד כבר קיים",
        "The room number format error.": "שגיאת פורמט מספר החדר.",
        "community not found": "הקהילה לא נמצאה",
        "resident not found": "תושב לא נמצא",
        "installer not found": "המתקין לא נמצא",
        "Operation Failed!": "הפעולה נכשלה!",
        "You don\'t have operate permission": "אין לך הרשאת הפעלה",
        "You cannot select Relay and Door at the same time": "אינך יכול לבחור ממסר ודלת בו זמנית",
        "user don\'t active": "המשתמש לא פעיל",
        "User has expired": "המשתמש פג תוקף",
        "timestamp must be within 3 minutes of current server time": "timestamp חייב להיות בטווח של 3 דקות מזמן השרת הנוכחי",
        "cannot find single rf Card.": "לא ניתן למצוא כרטיס rf בודד.",
        "cannot find community rf Card.": "לא ניתן למצוא את כרטיס הקהילה rf Card.",
        "smartLock model": "דגם smartLock",
        "the project does not open smart home": "הפרויקט לא פותח בית חכם",
        "php web server error": "שגיאת שרת אינטרנט של php",
        "Ins not found.": "Ins לא נמצא.",
        "RentManage Unit Not Set.": "יחידת RentManage לא הוגדרה.",
        "add audit log error": "הוסף שגיאת יומן ביקורת",
        "check building in error": "בדוק שגיאה בבניין",
        "Special devices cannot be deleted": "לא ניתן למחוק מכשירים מיוחדים",
        "the email is empty": "הדוא\"ל ריק",
        "the email format is incorrect": "פורמט הדוא\"ל שגוי",
        "the mobile number is empty": "מספר הטלפון הנייד ריק",
        "the mobile number format is incorrect": "פורמט מספר הטלפון הנייד שגוי",
        "Site not found": "האתר לא נמצא",
        "User not found": "המשתמש לא נמצא",
        "invalid time format": "פורמט זמן לא חוקי",
        "ground floor type": "סוג קומה קרקע",
        "Start floor range error, valid values are -10 to -1, G0, G1, G2, 1 to 128.": "שגיאת טווח קומה התחלתית, הערכים התקינים הם -10 עד -1, G0, G1, G2, 1 עד 128.",
        "Building ID must be between 1 and 99.": "מזהה הבניין חייב להיות בין 1 ל-99.",
        "Community building name": "שם בניין הקהילה",
        "Building ID already exists in this community.": "מזהה הבניין כבר קיים בקהילה זו.",
        "building ID": "מזהה בניין",
        "Community building not found.": "לא נמצא בניין קהילתי.",
        "Cannot delete building because it has associated devices.": "לא ניתן למחוק את הבניין כי יש לו מכשירים משויכים.",
        "project is not valid": "הפרויקט אינו תקף",
        "Cannot delete building because it has associated salto devices.": "לא ניתן למחוק את הבניין כי יש לו התקני salto משויכים.",
        "Cannot delete building because it has associated iTec devices.": "לא ניתן למחוק את הבניין כי יש לו מכשירי iTec משויכים.",
        "Cannot delete building because it has associated dormakaba devices.": "לא ניתן למחוק את הבניין כי יש לו מכשירי dormakaba משויכים.",
        "member limit num": "מספר הגבלת חברים",
        "Indoor Monitor No Set Error.": "Indoor Monitor No Set Error.",
        "The room not has indoor": "החדר לא כולל פנים",
        "check user in building error": "בדוק משתמש בבניין שגיאה",
        "The name specified is already in use.": "השם שצוין כבר בשימוש.",
        "This timeblock overlaps with an existing one. Please adjust it.": "בלוק הזמן הזה חופף לבלוק זמן קיים. אנא התאם אותו.",
        "This door status changed. Please try again.": "סטטוס הדלת השתנה. אנא נסה שוב.",
        "the lock can\'t bind this community": "המנעול לא יכול לקשור את הקהילה הזו",
        "The custom quantity limit has been exceeded!": "חרגת ממגבלת הכמות המותאמת אישית!",
        "This time span overlaps with an existing one. Please adjust it.": "טווח הזמן הזה חופף לטווח קיים. אנא התאם אותו.",
        "This one time runs overlap with an existing one time runs effective time. Please adjust it.": "הפעלה חד-פעמית זו חופפת לזמן הפעולה של הפעלה חד-פעמית קיימת. אנא התאם זאת.",
        "Operation Failed. Please try again.": "הפעולה נכשלה. אנא נסה שוב.",
        "The image is not a front view.": "התמונה אינה תצוגה קדמית.",
        "A mask was detected.": "זוהתה מסכה.",
        "The image resolution is too low.": "רזולוציית התמונה נמוכה מדי.",
        "No face was detected.": "לא זוהתה פנים.",
        "The file size is too large.": "גודל הקובץ גדול מדי.",
        "The face in the image is too large.": "הפנים בתמונה גדולות מדי.",
        "The face in the image is too small.": "הפנים בתמונה קטנות מדי.",
        "Multiple faces detected.": "זוהו מספר פנים.",
        "The face is not clear enough.": "הפנים אינן ברורות מספיק.",
        "Face detection failed.": "זיהוי פנים נכשל.",
        "Please enter a value between 1 and 9999": "אנא הזן ערך בין 1 ל-9999",
        "Please select which input your door sensor is connected to.": "אנא בחר לאיזה קלט מחובר חיישן הדלת שלך.",
        "Add temp key failed, please try it again": "הוספת מפתח זמני נכשלה, אנא נסה שוב",
        "Dis Not Support Dynamic QRCode Error.": "שגיאת Dis Not Support Dynamic QRCode.",
        "QR code not exist": "קוד QR לא קיים",
        "The temp key has expired.": "מפתח הזמני פג תוקף.",
        "The device is not in the office": "ההתקן אינו במשרד",
        "The device is already assigned.": "המכשיר כבר מוקצה.",
        "The device cannot be assigned to any user.": "לא ניתן להקצות את המכשיר לאף משתמש.",
        "You cannot select an option with fewer users than the current project members.": "אינך יכול לבחור אפשרות עם פחות משתמשים ממספר חברי הפרויקט הנוכחיים.",
        "File check failed. Please download the latest template and try again.": "בדיקת הקובץ נכשלה. נא להוריד את התבנית העדכנית ולנסות שוב.",
        "Dynamic QR Code not active.": "קוד QR דינמי אינו פעיל.",
        "Dynamic QR Code not enable.": "קוד QR דינמי לא הופעל.",
        "{0} not found.": "‏{0} לא נמצא.",
        "Tier charge plan": "תוכנית תשלום מדורגת",
        "Feature billing charge plan new": "תוכנית חיוב תכונה חדשה",
        "Feature billing gradient charge plan": "תוכנית חיוב מדורגת עבור תכונה",
        "The exit time cannot be earlier than the entry time.": "זמן היציאה לא יכול להיות מוקדם מזמן הכניסה.",
        "User Name or Password": "שם משתמש או סיסמה",
        "You can only link up to 5 sites.": "ניתן לקשר עד 5 אתרים בלבד.",
        "This license plate is already registered to a resident and cannot be added to the blocklist.": "לוחית הרישוי הזו כבר רשומה לדייר ואי אפשר להוסיף אותה לרשימת החסימה.",
        "This license plate is blocklisted and cannot be registered as a vehicle.": "לוחית רישוי זו נמצאת ברשימת החסימה ואינה ניתנת לרישום כרכב.",
        "Elevator not configured in company access floor.": "המעלית אינה מוגדרת בקומת הגישה של החברה.",
        "the device is not in the office": "ההתקן אינו במשרד",
        "A maximum of 1000 data items can be imported": "ניתן לייבא לכל היותר 1000 פריטי נתונים",
        "Exit time cannot be later than the current time.": "זמן היציאה לא יכול להיות מאוחר מהזמן הנוכחי.",
        "You can only import a file at a time in the current parking lot.": "בחניון הנוכחי ניתן לייבא קובץ אחד בכל פעם בלבד.",
        "The license plate is already in the blocklist.": "לוחית הרישוי כבר נמצאת ברשימת החסימה.",
        "Building name too long.": "שם הבניין ארוך מדי.",
        "Unlock failed. Permission denied by user.": "הפתיחה נכשלה. ההרשאה נדחתה על ידי המשתמש.",
        "Please remove the sensor device(s) before disabling this feature.": "אנא הסר/י את התקן/י החיישן לפני השבתת תכונה זו.",
        "Operation failed! Daily limit of 15 records exceeded for this user.": "הפעולה נכשלה! המשתמש הזה חרג ממגבלת 15 הרשומות היומית.",
        "A maximum of {0} public devices can be created within a single project. If you need to add more public devices, please contact Akuvox Technical Support at support@akuvox.com.": "ניתן להוסיף עד {0} מכשירים ציבוריים לכל פרויקט. כדי להוסיף עוד, יש לפנות לתמיכה הטכנית של Akuvox בכתובת support{'@'}akuvox.com.",
        "A maximum of {0} apartment devices can be created within a single project. If you need to add more apartment devices, please contact Akuvox Technical Support at support@akuvox.com.": "Up to {0} apartment devices can be added per project. To add more, please contact Akuvox Technical Support at support{'@'}akuvox.com.",
        "A maximum of {0} buildings can be created within a single project. If you need to add more buildings, please contact Akuvox Technical Support at support@akuvox.com.": "Up to {0} buildings can be added per project. To add more, please contact Akuvox Technical Support at support{'@'}akuvox.com.",
        "A maximum of {0} apartments can be created within a single project. If you need to add more apartments, please contact Akuvox Technical Support at support@akuvox.com.": "Up to {0} apartments can be added per project. To add more, please contact Akuvox Technical Support at support{'@'}akuvox.com.",
        "A maximum of {0} residents can be created within a single project. If you need to add more residents, please contact Akuvox Technical Support at support@akuvox.com.": "Up to {0} residents can be added per project. To add more, please contact Akuvox Technical Support at support{'@'}akuvox.com.",
        "A maximum of {0} delivery personnel can be created within a single project. If you need to add more delivery personnel, please contact Akuvox Technical Support at support@akuvox.com.": "Up to {0} delivery personnel can be added per project. To add more, please contact Akuvox Technical Support at support{'@'}akuvox.com.",
        "A maximum of {0} access groups can be created within a single project. If you need to add more access groups, please contact Akuvox Technical Support at support@akuvox.com.": "Up to {0} access groups can be added per project. To add more, please contact Akuvox Technical Support at support{'@'}akuvox.com.",
        "A maximum of {0} office groups can be created within a single project. If you need to add more office groups, please contact Akuvox Technical Support at support@akuvox.com.": "Up to {0} office groups can be added per project. To add more, please contact Akuvox Technical Support at support{'@'}akuvox.com.",
        "A maximum of {0} admins can be created within a single project. If you need to add more admins, please contact Akuvox Technical Support at support@akuvox.com.": "Up to {0} admins can be added per project. To add more, please contact Akuvox Technical Support at support{'@'}akuvox.com.",
        "A maximum of {0} companies can be created within a single project. If you need to add more companies, please contact Akuvox Technical Support at support@akuvox.com.": "Up to {0} companies can be added per project. To add more, please contact Akuvox Technical Support at support{'@'}akuvox.com.",
        "A maximum of {0} personnel accounts can be created within a single project. If you need to add more personnel accounts, please contact Akuvox Technical Support at support@akuvox.com.": "ניתן להוסיף עד {0} חשבונות עובדים לכל פרויקט. כדי להוסיף עוד, יש לפנות לתמיכה הטכנית של Akuvox בכתובת support{'@'}akuvox.com.",
        "cancel": "לבטל",


    }
};
